<template>
  <div class="gallery_wrap">
    <div class="tutorial_wrap z-20 absolute" v-if="showTutorial">
      <div
        id="tutorial"
        class="
          absolute
          w-10/12
          border-2 border-white
          rounded-lg
          text-center text-lg
          py-5
        "
      >
        <button
          class="bg-gray-500 absolute top-3 right-3 p-3 rounded-full"
          @click="[(showTutorial = false), fetch()]"
        >
          <img src="../../assets/images/close_btn.png" alt="닫기" class="w-2" />
        </button>

        <div class="">
          <img src="../../assets/images/guide.png" />
        </div>
      </div>
    </div>
    <div
      class="
        header
        absolute
        w-full
        z-20
        left-0
        top-0
        flex
        justify-between
        align-middle
      "
    >
      <div class="ml-4 mt-4 w-10" @click="onOtherGalleries = !onOtherGalleries">
        <img
          class="icon"
          src="../../assets/images/gallery/group.png"
          alt="다른 사용자 가상전시관 보기"
        />
      </div>
      <div class="mt-2 w-16">
        <img class="logo" src="../../assets/images/logo-main.png" alt="로고" />
      </div>
      <div class="m-4">
        <button @click="onBack()">
          <img
            src="../../assets/images/close_btn2.png"
            alt="닫기"
            class="w-6 m-auto"
          />
        </button>
      </div>
    </div>

    <user-gallery-list class="other_gallery" v-if="onOtherGalleries" />

    <!-- 5개 유물 배치 -->
    <gallery-display-scroll
      v-if="!showTutorial"
      :items="galleryRelics"
      :userId="usersId"
      :myRelics="myRelics"
      :galleryId="galleryId"
    ></gallery-display-scroll>
    <!-- <gallery-display-copy
      v-if="!showTutorial"
      :items="galleryRelics"
      :userId="usersId"
      :myRelics="myRelics"
      :galleryId="galleryId"
    ></gallery-display-copy> -->
    <!-- <div class="bg_wall"></div> -->
    <div class="gallery_main">
      <a-scene
        embedded
        background="color: #112"
        vr-mode-ui="enabled: false"
        device-orientation-permission-ui="enabled: false"
      >
        <a-assets timeout="30000">
          <img id="floor" src="../../assets/images/gallery/stone-texture.jpg" />
          <img id="wall" src="../../assets/images/gallery/gray.jpg" />

          <!-- Layout mixins.-->
          <a-mixin
            id="column"
            geometry="primitive: box; depth: 1.5; height: 3; width: 1.5"
            material="color: #FFF"
            position="0 1 0"
          ></a-mixin>
          <a-mixin
            id="column-bottom"
            geometry="primitive: box; depth: 1.75; height: .1; width: 2;"
            material="color: #FFF"
            position="0 .1 0"
          ></a-mixin>
          <a-mixin
            id="column-light"
            light="type: point; intensity: 0.5; distance: 5;"
            position="0 1.5 0"
          ></a-mixin>
          <a-mixin id="object-on-column" position="0 1.2 2"></a-mixin>

          <!-- <Components> -->
          <a-mixin
            id="back-plane"
            geometry="primitive: plane;"
            material="side: back"
          ></a-mixin>
          <a-mixin
            id="front-plane"
            geometry="primitive: plane;"
            material="side: front"
          ></a-mixin>
          <a-mixin
            id="box"
            geometry="primitive: box;"
            material="opacity:0;"
          ></a-mixin>
          <a-mixin
            id="window"
            material="opacity: 0.8"
            scale="1 1 0.01"
          ></a-mixin>
        </a-assets>
        <a-camera position="0 3 4"></a-camera>
        <!-- Floor. -->
        <a-entity
          geometry="primitive: box; depth: 20; height: .2; width : 20"
          material="src: #floor; metalness: .2; repeat: 50 20; roughness: .1"
          position="0 0 0"
        ></a-entity>

        <!-- Lights. -->
        <a-entity light="type: ambient; color: #444"></a-entity>
        <a-entity
          light="type: directional; color: #EEE"
          position="0 1 1"
        ></a-entity>

        <!-- 안쪽 왼쪽 전시대 -->
        <a-entity position="-7 0 0">
          <a-entity mixin="column">
            <a-entity mixin="column-light"></a-entity>
            <a-entity
              mixin="object-on-column color box spin"
              animation__spin="to: 360 360 0"
            ></a-entity>
            <a-entity
              mixin="object-on-column color box spin"
              position=".18 1.2 .1"
              animation__spin="to: 360 360 0"
            ></a-entity>
            <a-entity
              mixin="object-on-column color box spin"
              position="-.18 1.2 -.2"
              animation__spin="to: 360 360 0"
            ></a-entity>
          </a-entity>
          <a-entity mixin="column-bottom"></a-entity>
        </a-entity>

        <!-- 뒤쪽 왼쪽 전시대 -->
        <a-entity position="-5 0 -7">
          <a-entity mixin="column">
            <a-entity mixin="column-light"></a-entity>
            <a-entity
              mixin="object-on-column color box spin"
              animation__spin="to: 360 360 0"
            ></a-entity>
            <a-entity
              mixin="object-on-column color box spin"
              position=".18 1.2 .1"
              animation__spin="to: 360 360 0"
            ></a-entity>
            <a-entity
              mixin="object-on-column color box spin"
              position="-.18 1.2 -.2"
              animation__spin="to: 360 360 0"
            ></a-entity>
          </a-entity>
          <a-entity mixin="column-bottom"></a-entity>
        </a-entity>
        <!-- 뒤쪽 가운데 전시대 -->
        <a-entity position="0 0 -7">
          <a-entity mixin="column">
            <a-entity mixin="column-light"></a-entity>
            <a-entity
              mixin="object-on-column color box spin"
              animation__spin="to: 360 360 0"
            ></a-entity>
            <a-entity
              mixin="object-on-column color box spin"
              position=".18 1.2 .1"
              animation__spin="to: 360 360 0"
            ></a-entity>
            <a-entity
              mixin="object-on-column color box spin"
              position="-.18 1.2 -.2"
              animation__spin="to: 360 360 0"
            ></a-entity>
          </a-entity>
          <a-entity mixin="column-bottom"></a-entity>
        </a-entity>

        <!-- 뒤쪽 오른쪽 전시대 -->
        <a-entity position="5 0 -7">
          <a-entity mixin="column">
            <a-entity mixin="column-light"></a-entity>
            <a-entity
              mixin="object-on-column color box spin"
              animation__spin="to: 360 360 0"
            ></a-entity>
            <a-entity
              mixin="object-on-column color box spin"
              position=".18 1.2 .1"
              animation__spin="to: 360 360 0"
            ></a-entity>
            <a-entity
              mixin="object-on-column color box spin"
              position="-.18 1.2 -.2"
              animation__spin="to: 360 360 0"
            ></a-entity>
          </a-entity>
          <a-entity mixin="column-bottom"></a-entity>
        </a-entity>

        <!-- 안쪽 오른쪽 전시대 -->
        <a-entity position="7 0 0">
          <a-entity mixin="column">
            <a-entity mixin="column-light"></a-entity>
            <a-entity
              mixin="object-on-column color box spin"
              animation__spin="to: 360 360 0"
            ></a-entity>
            <a-entity
              mixin="object-on-column color box spin"
              position=".18 1.2 .1"
              animation__spin="to: 360 360 0"
            ></a-entity>
            <a-entity
              mixin="object-on-column color box spin"
              position="-.18 1.2 -.2"
              animation__spin="to: 360 360 0"
            ></a-entity>
          </a-entity>
          <a-entity mixin="column-bottom"></a-entity>
        </a-entity>

        <!-- <a-entity environment="preset :default"></a-entity> -->

        <!--SKELETON-->
        <a-entity id="skeleton">
          <a-entity
            class="the-right-side-wall"
            mixin="back-plane"
            material="src: #wall; metalness: .2;"
            rotation="0 90 0"
            geometry="width:20;height:6; "
            position="10 2.9 "
            static-body
          >
          </a-entity>

          <a-entity
            id="the-left-side-wall"
            mixin="front-plane"
            material="src: #wall; metalness: .2;"
            geometry="height:6;width:20; "
            rotation="0 90 0"
            position="-10 2.9 0"
            static-body
          >
            <!-- <a-entity id="img1" mixin="frame1" position="-7 0 0.01"></a-entity>-->
          </a-entity>

          <a-entity
            id="the-back-wall"
            mixin="front-plane"
            material="src: #wall; metalness: .2;"
            geometry="height:6;width:20;"
            position="0 2.9 -10"
            static-body
          >
            <!-- <a-entity mixin="bong1" position="5 0 0.01"></a-entity> -->
            <!-- <a-entity gltf-model="url(https://cdn.eeewwwaframe.io/examples/ar/models/triceratops/scene.gltf)" scale="0.01 0.01 0.01" position="5 -2.75 2"></a-entity> -->
            <!-- 윤장대
            <a-entity
              gltf-model="url(http://localhost:3005/api/files/load/file-1647420440093.glb)"
              scale="0.05 0.05 0.05"
              position="8 0.2 7.1"
            ></a-entity> -->
            <!-- 칼
            <a-entity
              gltf-model="url(http://localhost:3005/api/files/load/file-1647589152360.glb)"
              scale="0.05 0.05 0.05"
              position="-8 0.2 7.25"
            ></a-entity> -->
            <!-- 탑
            <a-entity
              gltf-model="url(http://localhost:3005/api/files/load/file-1647590842924.glb)"
              scale="0.05 0.05 0.05"
              position="0 -2.5 12"
            >
            </a-entity>-->
          </a-entity>
          <a-entity id="the-front-wall">
            <a-entity id="the-front-wall-door">
              <a-entity>
                <a-entity
                  class="left"
                  mixin="window"
                  geometry="primitive:box;height:6;width:3; "
                  position="-1.51 2.9 10"
                  static-body
                ></a-entity>
                <a-entity
                  class="right"
                  mixin="window"
                  geometry="primitive:box;height:6;width:3; "
                  position="1.51 2.9 10"
                  static-body
                ></a-entity>
              </a-entity>
            </a-entity>
            <a-entity
              mixin="window"
              material="src: #wall; metalness: .2;"
              geometry="primitive:box;height:6;width:7.5; "
              position="6.75 2.9 10"
              static-body
            ></a-entity>
            <a-entity
              mixin="window"
              material="src: #wall; metalness: .2;"
              geometry="primitive:box;height:6;width:7.5; "
              position="-6.75 2.9 10"
              static-body
            ></a-entity>
          </a-entity>

          <a-entity
            id="roof"
            material="src: #floor; metalness: .2; repeat: 50 20;"
            mixin="front-plane"
            geometry="width:20;height:20; "
            rotation="90 0 0"
            position="0 5.75 0"
            static-body
          >
            <a-entity
              light="type: directional; color: #EEE; intensity: 0.2"
            ></a-entity>
          </a-entity>
        </a-entity>
        <!--SKELETON-->
      </a-scene>
    </div>
  </div>
</template>

<script>
import UserGalleryList from "../../components/UserGalleryList.vue";
import GalleryDisplayScroll from "../../components/GalleryDisplayScroll.vue";
// import GalleryDisplayCopy from "../../components/GalleryDisplayCopy.vue";
import services from "../../services";
export default {
  components: { UserGalleryList, GalleryDisplayScroll },
  name: "Gallery",
  data() {
    return {
      onOtherGalleries: false,
      showTutorial: false,
      galleryId: 0,
      usersId: 0,
      myRelics: [],
      galleryRelics: [],
    };
  },
  created() {
    this.fetch();
  },
  methods: {
    onBack() {
      if ( window.history.length > 1 ) {
        this.$router.go(-1);
      } else {
        this.$router.push("/");
      }
    },    
    async fetch() {
      await services.findMyInfoByToken().then(
        (response) => {
          const { data } = response;
          this.usersId = data.id;
          this.findMyGallery(this.usersId);
        },
        (error) => {
          const { data } = error.response;
          console.log(data);
          this.router.push({ name: "Login" });
        }
      );
    },
    async findMyGallery(id) {
      const params = { usersId: id };
      await services.galleryFindOneByUserId(params).then(
        (response) => {
          const { data } = response;
          if (data.totalItems) {
            this.galleryId = data.items[0].id;
            this.findMyGalleryRelic();
            this.findMyRelics();
          } else {
            this.showTutorial = true;
            this.regGallery();
          }
        },
        (error) => {
          const { data } = error.response;
          console.log(data);
        }
      );
    },
    async regGallery() {
      await services.regGallery().then(
        (response) => {
          const { data } = response;
          this.galleryId = data.items[0].id;
          this.galleryRelics = [];
          this.findMyRelics();
        },
        (error) => {
          const { data } = error.response;
          console.log(data);
        }
      );
    },
    // XXX 내전시관에 배치된 유물
    async findMyGalleryRelic() {
      services
        .galleryRelicFindByGalleryId({ galleriesId: this.galleryId, size:20 })
        .then(
          (response) => {
            const { data } = response;
            this.galleryRelics[0] = data.items.find((item) => item.number == 1);
            this.galleryRelics[1] = data.items.find((item) => item.number == 2);
            this.galleryRelics[2] = data.items.find((item) => item.number == 3);
            this.galleryRelics[3] = data.items.find((item) => item.number == 4);
            this.galleryRelics[4] = data.items.find((item) => item.number == 5);
            this.galleryRelics[5] = data.items.find((item) => item.number == 6);
            this.galleryRelics[6] = data.items.find((item) => item.number == 7);
            this.galleryRelics[7] = data.items.find((item) => item.number == 8);
            this.galleryRelics[8] = data.items.find((item) => item.number == 9);
            this.galleryRelics[9] = data.items.find(
              (item) => item.number == 10
            );
            this.galleryRelics[10] = data.items.find(
              (item) => item.number == 11
            );
            this.galleryRelics[11] = data.items.find(
              (item) => item.number == 12
            );
            console.log(this.galleryRelics);
            const parseString = require("xml2js").parseString;
            this.galleryRelics.forEach((item) => {
              if (item) {
                parseString(item.usersRelics.relics.name, (error, result) => {
                  if (result.lang) {
                    switch (this.$i18n.locale) {
                      case "ko":
                        item.usersRelics.relics.name = result.lang.ko[0];
                        break;
                      case "en":
                        item.usersRelics.relics.name = result.lang.en[0];
                        break;
                      case "child":
                        item.usersRelics.relics.name = result.lang.ko[0];
                        break;
                      case "zh":
                        item.usersRelics.relics.name = result.lang.zh[0];
                        break;
                      case "ja":
                        item.usersRelics.relics.name = result.lang.ja[0];
                        break;
                      default:
                        item.usersRelics.relics.name = result.lang.ko[0];
                    }
                    if (!item.usersRelics.relics.name) {
                      item.usersRelics.relics.name = result.lang.ko[0];
                    }
                  } else if (error) {
                    console.log(error);
                  }
                });

                parseString(
                  item.usersRelics.relics.essential,
                  (error, result) => {
                    if (result.lang) {
                      switch (this.$i18n.locale) {
                        case "ko":
                          item.usersRelics.relics.essential = result.lang.ko[0];
                          break;
                        case "en":
                          item.usersRelics.relics.essential = result.lang.en[0];
                          break;
                        case "child":
                          item.usersRelics.relics.essential =
                            result.lang.ko[0];
                          break;
                        case "zh":
                          item.usersRelics.relics.essential = result.lang.zh[0];
                          break;
                        case "ja":
                          item.usersRelics.relics.essential = result.lang.ja[0];
                          break;
                        default:
                          item.usersRelics.relics.essential = result.lang.ko[0];
                      }
                      if (!item.usersRelics.relics.essential) {
                        item.usersRelics.relics.essential = result.lang.ko[0];
                      }
                    } else if (error) {
                      console.log(error);
                    }
                  }
                );
              }
            });
          },
          (error) => {
            const { data } = error.response;
            console.log(data);
          }
        );
    },

    async findMyRelics() {
      services.userRelicFindAll({ usersId: this.usersId, size: 1000 }).then(
        (response) => {
          const { data } = response;
          this.myRelics = data.items;
        },
        (error) => {
          const { data } = error.response;
          console.log(data);
        }
      );
    },
  },
};
</script>

<style>
.header div img {
  filter: drop-shadow(1px 1px 1px #333);
}
.gallery_wrap {
  width: 100%;
  height: 100%;
  overflow-y: hidden;
}

.tutorial_wrap {
  width: 100%;
  height: 100%;
  background: url("../../assets/images/gallery/gallery_entrance.jpg") no-repeat
    center;
  background-size: 100% 100%;
}

#tutorial {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(255, 255, 255, 0.8);
}

.show_relic_btn {
  background: rgba(255, 255, 255, 0.7);
  transform: translateX(50%);
}
.other_gallery ul {
  padding-top: 70px;
}

/* .bg_wall {
  height: 100%;
  margin-top: 10px;
  background: url("../../assets/images/gallery/gallery_wall.png") no-repeat
    center;
  filter: blur(4px);
} */
</style>
